var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`text-[#b5b5b5a4] bg-clip-text inline-block ${!_vm.disabled ? 'animate-shine' : ''} ${_vm.className}`,style:({
    backgroundImage:
      'linear-gradient(120deg, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 60%)',
    backgroundSize: '200% 100%',
    WebkitBackgroundClip: 'text',
    animationDuration: _vm.animationDuration
  })},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }